import type { BizIconProps } from './base';
import BizIconSvg from './base';

/** IconChartBar — 运营分析 / 报表中心：柱状图 */
export default function IconChartBar(props: BizIconProps) {
  return (
    <BizIconSvg {...props}>
      <rect x="2.67" y="8.67" width="2.67" height="4.67" rx="0.67" />
      <rect x="6.67" y="5.33" width="2.67" height="8" rx="0.67" />
      <rect x="10.67" y="2.67" width="2.67" height="10.67" rx="0.67" />
    </BizIconSvg>
  );
}
